import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const DailyCounterReport = MatxLoadable({
  loader: () => import("./DailyCounterReport")
})

const DailyCounterReportRoutes = [
  {
    path: "/daily_counter_report",
    component: DailyCounterReport,
    auth: authRoles.admin
  }
];

export default DailyCounterReportRoutes;